import React, {useMemo, useState} from "react";
import {NavLink, useHistory} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {clearPartnerWorkstationState} from "../../ClientManagement/PartnerWorkstation/partnerWorkstationSlice";
import AppHeader from "./AppHeader";
import {useMsal} from "@azure/msal-react";
import {handleLogout} from "../../MsalUtils";
import LogoutModal from "../Modal/Logout/LogoutModal";
import {selectActiveMeeting, selectParticipatingInMeeting} from "../../ClientManagement/Meeting/meetingSlice";
import {Meeting} from "../../ClientManagement/Meeting/Meeting";

const Header: React.FC = () => {
    const history = useHistory();
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

    const dispatch = useAppDispatch();
    const msal = useMsal();

    const isParticipatingInMeeting = useAppSelector(selectParticipatingInMeeting);
    const activeMeeting = useAppSelector(selectActiveMeeting) as Meeting;

    const navigateHome = () => {
        dispatch(clearPartnerWorkstationState());
        if(isParticipatingInMeeting) {
            history.push({pathname: `/Profile/${activeMeeting.profileId}`})
        }
        else {
            history.push({pathname: `/`})
        }
    }

    const logoutLink = useMemo(() => {
        return [
            {
                id: 'Logout',
                name: "log out",
                enabled: true,
                customHandler: () => setIsLogoutModalOpen(true)
            }
        ]
    }, [])

    const onClickLogout = () => {
        handleLogout(msal);
    }
    const onClickCancel = () => {
        setIsLogoutModalOpen(false);
    }

    return (
        <>
            <AppHeader
                appTitle="Goals Driven Wealth Management"
                onLogoClick={navigateHome}
                links={logoutLink}
                LinkRenderer={NavLink}
                headerToolbarAlignment="center"
                navigationStyle="header"
            />
            <LogoutModal isOpen={isLogoutModalOpen} onClickCancel={onClickCancel} onClickLogout={onClickLogout}/>
        </>
    )
};

Header.displayName = "Header";
export default Header;

